import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';
import Menu, { menuClasses } from '@mui/material/Menu';
import { Dispatch, ReactNode, SetStateAction } from 'react';

type SidebarActionMenuProps = {
    anchorEl: HTMLElement | null;
    setAnchorEl: Dispatch<SetStateAction<HTMLElement | null>>;
    children: ReactNode | ReactNode[];
    icon?: ReactNode;
};

export default function SidebarActionMenu({
    anchorEl,
    setAnchorEl,
    children,
    icon,
}: SidebarActionMenuProps) {
    return (
        <>
            <IconButton
                color="primary"
                size="small"
                aria-controls="sidebar-action-menu"
                aria-haspopup="true"
                data-testid="sidebar-action-menu"
                onClick={(event) => setAnchorEl(event.currentTarget)}
            >
                {icon ? icon : <MoreVertIcon sx={{ fontSize: 16 }} />}
            </IconButton>
            <Menu
                id="sidebar-action-menu"
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                sx={{
                    width: 'calc(240px + 8px)',
                    ml: -0.5,
                    [`& .${menuClasses.paper}`]: {
                        width: '240px',
                        marginTop: '4px',
                    },
                }}
                MenuListProps={{ dense: true }}
            >
                {children}
            </Menu>
        </>
    );
}
